import React from 'react';
import PropTypes from 'prop-types';
import { getIconSVGNameFromSlug } from '../../../../../../lib/utils';
import { ICON_DISPLAY_MAP } from '../../../../../../lib/constants';
import styles from './StyleCircle.module.scss';
import TypeIcons from '../../../../../../assets/featureType';

export default function StyleCircle(props) {
  const onClickCircle = (color, icon) => {
    return () => props.onClick({ color, icon })
  };

  const isLightBG = () => {
    return props.color.toLowerCase() === '#ffffff' || props.color.toLowerCase() === '#ffcc00' ; 
  };

  const reactStyles = {
    circleContainer: {
      backgroundColor: props.color,
      border: props.active ? '2px solid #fff' : 'none',
    },
    styleText: {
      ...props.styleText
    }
  }

  return (
    <div onClick={onClickCircle(props.color, props.icon)} className={styles.container}>
      <div style={reactStyles.circleContainer} className={styles.circleContainer}>
        <img className={!isLightBG() ? styles.iconInvert : ''} src={TypeIcons[getIconSVGNameFromSlug(props.icon)]} />
      </div>
      <p style={reactStyles.styleText} className={styles.styleText}>{ICON_DISPLAY_MAP[props.icon]}</p>
    </div>
  );
}

StyleCircle.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,
  icon: PropTypes.string,
  styleText: PropTypes.object,
  onClick: PropTypes.func,
};

StyleCircle.defaultProps = {
  color: '#f37735',
};
